export enum damageAssignments {
  partiallyComprehensive = 'partiallyComprehensive',
  fullyComprehensive = 'fullyComplrehensive',
  liability = 'liability',
  letterOfProtection = 'letterOfProtection',
}
